import type { Psychologist } from "../../../types/psychologist";
import PsychologistProfile from "../../../components/psychologist/PsychologistProfile";
import { usePsychologistContext } from "../../../contexts/PsychologistContext";
import { useAuth } from "../../../contexts/AuthContext";

interface ProfileTabProps {
  psychologist: Psychologist | null;
  onDirtyChange?: (dirty: boolean) => void;
}

export const ProfileTab = ({ psychologist, onDirtyChange }: ProfileTabProps) => {
  const { services, servicesLoading } = usePsychologistContext();
  const { user } = useAuth();

  return (
    <section className="config-section profile-transparent">
      <style>{`
        .config-section.profile-transparent { background: transparent !important; padding: 0 !important; border: 0 !important; box-shadow: none !important; }
        .config-section.profile-transparent .psychologist-profile-container { background: transparent !important; padding: 0 !important; min-height: auto !important; }
      `}</style>
      <PsychologistProfile
        name={user?.name || psychologist?.name || psychologist?.nickname || ""}
        lastName={user?.surname || psychologist?.last_name || ""}
        services={services}
        servicesLoading={servicesLoading}
        onDirtyChange={onDirtyChange}
      />
    </section>
  );
};
